export default __webpack_public_path__ + "static/yuuLogoLarge_2-d3fb906f8245bdceb946501be242da2a.svg";